<template>
  <v-container>
    <v-card
    max-width="450"
    class="mx-auto mt-20">
    <v-list two-line>
      <v-subheader style="color:green;">Payment successful</v-subheader>
      <template v-for="(item) in selected">
          <v-list-item :key="item.index" @click="clickpatient(item)">
          <v-list-item-content>
              <v-list-item-title>{{item.patient_name}}, {{item.hospital}} </v-list-item-title>
              <v-list-item-subtitle> {{item.token_id}}</v-list-item-subtitle>
              <!-- <v-list-item-subtitle> {{item.uploaded_date}}</v-list-item-subtitle> -->
          </v-list-item-content>
          <v-icon style="padding-right:4px"
            v-if="item.paid"
            color="#00BEFF"
          >
            mdi-checkbox-marked-circle
          </v-icon>
          <div style=" margin-right:16px;" v-if="item.paid">paid</div>
          </v-list-item>
      </template>
    </v-list>
    <div class="center py-20">
    已完成付款，請至查看影像頁面檢視影像
    <div class="py-20">
    <v-btn color="#00BEFF" outlined :to="'/'">
      Go back
    </v-btn>
    </div>
    </div>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data(){
    return{
      selected:[],
      formdata:{},
      //call backend to get all token with image data
      list:[
        { 
          token_id:'aaa1234',
          uploaded_date:'2021/10/1',
          patient_name:'§ xx',
          hospital:'NTUH',
          paid:false
        },
        { 
          token_id:'aaa234',
          uploaded_date:'2021/10/2',
          patient_name:'§ xxx',
          hospital:'MIMH',
          paid:false
        }
      ]
    }
  },
  mounted(){
    // let formdata = window.location.search; 
    // this.formdata = formdata;
    // console.log(formdata);
    let paid = localStorage.getItem('selected')
    let paid_arr = paid.split(',');
    console.log(paid,paid_arr);
    for(var i=0; i<paid_arr.length; i++)
    {
      for(var j=0; j<this.list.length; j++)
      {
        if(paid_arr[i]==this.list[j].token_id)
        {
          this.list[j].paid = true
          this.selected.push(this.list[j])
        }
      }
    }
    console.log( this.selected);

  },
  methods:{
    //mpg gives formdata to call this page
    //extract that form data ??


    //in that form data -> 5 attributes

    //get that attribute and call api to receive token to show in ui which images are paid.

    clickpatient(item){
      console.log("patient info",item);
    }
  }
}
</script>
<style scoped>
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.center{
  text-align: center;
}
.py-20{
  padding-top: 20px;
  padding-bottom: 20px;
}
.mt-20{
  margin-top: 20px;
}
</style>
